import {Component} from '@angular/core';
import {AppComponent} from './app.component';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
            <a id="footerlogolink">
                <img id="footer-logo" style="width:50px"
                     [src]="'assets/ck-capital-finance-logo.png'" alt="CK Logo">
            </a>
            <div class="social-icons">
                <a href="https://www.facebook.com/ckcapitalfinance/"><i class="pi pi-facebook"></i></a>
            </div>
        </div>
    `
})
export class AppFooterComponent {

    constructor(public app: AppComponent) {}


}
